import { ScreenEnum } from './types'

// тип устройста пользователя по размеру экрана
export const getScreen = (screenWidth: number) => {
  if (screenWidth < 768) return ScreenEnum.mobile
  if (screenWidth < 1280) return ScreenEnum.tablet

  return ScreenEnum.desktop
}
